(function($) {
           var cbcollapseHeight = 90;
          var cbmaxHeight = 'auto';
	  $('.cb-show-more').on('click',function(){
        var parent =  $(this).parents('.cb-text-more');
        if (!parent.hasClass('active')) {
          parent.find('.cb-more-content').css('height', cbmaxHeight);
          parent.addClass('active');
          parent.find('.cb-more').hide();
          parent.find('.cb-less').show();
        } else {
          parent.find('.cb-more-content').css('height',cbcollapseHeight + 'px');
          parent.removeClass('active');
          parent.find('.cb-more').show();
          parent.find('.cb-less').hide();
        }
  }) 

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
  


  if(getUrlParameter('contact_posted') == 'true' && $(".cb-tab-cb_ask").length > 0 ) {

     $([document.documentElement, document.body]).animate({
        scrollTop: $(".cb-tab-cb_ask").offset().top
    }, 1000);

    setTimeout(function(){
      $('.cb-tab-cb_ask').find('.toggle__title').click();
    },300)
     
  }
        

  $('#shopify-section-template--25161420898634__text_columns_icons_PCirAN').insertAfter('.main-collection-banner .cb-collection-head');
  setTimeout(function(){
    $('.template-product .product-text').find('#wishlisthero-product-page-button-container').appendTo('.product-gallery--slider css-slider')
  },1000)
  

    if (window.matchMedia("(max-width: 1023px)").matches) {
        $('mobile-navigation .link-list > .has-submenu').each(function(){
          const name = $(this).find('.cb-parent-title').text(),
                url = $(this).find('a').attr('href');
                
                $(this).find('.submenu .cb-parent-link span').text(name);
                $(this).find('.submenu .cb-parent-link a').attr('href', url);


                  $(this).find('.cb-parent-title2').each(function(){          
                   var name2 = $(this).text();
                   var url2 = $(this).parents('a.menu-link').attr('href');
                    $(this).parents('.has-babymenu').find('.cb-parent-link2 span').text(name2);
                    $(this).parents('.has-babymenu').find('.cb-parent-link2 a').attr('href', url2);
                })



        })
    } else {
      // Viewport is greater than 700 pixels wide
    }
    $(document).ready(function() {
	// console.log('ready!')
    });
})(jQuery);
